<template>
  <base-modal ref="modal" size="4xl">
    <base-card>
      <base-tabs class="tw-mt-4" :key="plans.length">
        <base-tab v-for="(plan, index) in plans" :key="plan.businessPlanId" :selected="!index" :title="plan.name">
          <BusinessPlanAgreement
            :business-plan-id="plan.businessId"
            :price-cents="plan.priceCents"
            :currency="plan.priceCurrency"
            :down-payment-cents="plan.downPaymentCents"
            :business-name="business.name"
            :term-length="plan.termLength"
            :term-interval="plan.termInterval"
            :cycle-frequency="plan.billingFrequency"
            :cycle-interval="plan.billingInterval"
            :service-fee-cents="plan.serviceFeeCents"
            class="tw-mt-3"
          />
        </base-tab>
      </base-tabs>
      <p class="tw-font-thin tw-mt-2">
        I agree to these Member Plan Terms and Conditions. I also agree to the Member Terms of Service and I acknowledge the Privacy Policy.
      </p>
      <div class="tw-mt-3">
        <a class="tw-mr-6 tw-text-primary" href="https://www.predictile.com/member-terms-of-service/index.html" target="_blank">Member Terms of Service</a>
        <a class="tw-text-primary" href="https://www.predictile.com/privacy-policy/index.html" target="_blank">Privacy Policy</a>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import BusinessPlanAgreement from "@/views/business/business-plans/components/BusinessPlanAgreement";

export default {
  components: {
    BusinessPlanAgreement,
  },
  props: {
    plans: Array,
    business: Object,
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>
